/**
 * Re-export from `@streamlain/workflow-field-schemas` — resolver is shared
 * across frontend + backend so insert-seed + panel see the same slug mapping.
 */

import {
  resolveNodeTypeSlug,
  resolveNodeTypeSlugFromType,
} from '@streamlain/workflow-field-schemas';

import type { EngineApiNode } from './workflow-adapter';

export { resolveNodeTypeSlug };

export function resolveNodeTypeSlugFromRawNode(rawNode: EngineApiNode): string {
  return resolveNodeTypeSlugFromType(rawNode.type, rawNode.parameters ?? {});
}
